import styled, { css } from "styled-components";
import Container from "../../atoms/Container/Container.styled";
import { withDisplayHeading } from "../../../themes/mixins";
import { deviceMax } from "../../../utils/device";

export const CollectionSection = styled.section`
  background: ${({ theme }) => theme.colors.brand.soft};
  padding: 86px 0;

  @media ${deviceMax.tabletWideMax} {
    padding: 64px 0;
  }

  @media ${deviceMax.phoneMax} {
    padding: 56px 0;
  }
`;

export const CollectionGrid = styled(Container)`
  align-items: center;
  display: grid;
  gap: 104px;
  grid-template-columns: 1fr 1fr;

  @media ${deviceMax.desktopSMax} {
    gap: 55px;
  }

  @media ${deviceMax.tabletWideMax} {
    gap: 36px;
  }

  @media ${deviceMax.phoneMax} {
    display: flex;
    flex-direction: column-reverse;
    gap: 32px;
  }
`;

export const CollectionVisual = styled.div(
  ({ theme }) => css`
    background: linear-gradient(140deg, #e8edf4, #f1ecf7 70%, #e8f8fc);
    border-radius: ${theme.layout.radius.surface};
    padding: 24px 35px 26px;
    position: relative;

    @media ${deviceMax.desktopSMax} {
      padding-left: 25px;
      padding-right: 25px;
    }

    @media ${deviceMax.tabletWideMax} {
      padding: 22px 16px;
    }

    @media ${deviceMax.phoneMax} {
      padding: 22px 18px;
      width: 100%;
    }
  `
);

export const CollectionCopy = styled.div``;

export const CollectionTitle = styled.h2`
  ${withDisplayHeading()};
  max-width: 530px;

  @media ${deviceMax.tabletWideMax} {
    font-size: 33px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 35px;
  }
`;

export const CollectionLead = styled.p`
  color: ${({ theme }) => theme.colors.brand.muted};
  font-size: 16px;
  line-height: 1.8;
  margin: 24px 0 0;
  max-width: 490px;

  @media ${deviceMax.tabletWideMax} {
    font-size: 14px;
    margin-top: 18px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 14px;
    line-height: 1.85;
  }
`;

export const FeatureLine = styled.div`
  align-items: flex-start;
  border-top: 1px solid #dce3ec;
  display: flex;
  gap: 15px;
  margin-top: 23px;
  padding-top: 23px;

  > svg {
    color: ${({ theme }) => theme.colors.brand.navy};
    margin-top: 2px;
  }

  @media ${deviceMax.tabletWideMax} {
    gap: 10px;
    margin-top: 17px;
    padding-top: 17px;
  }

  @media ${deviceMax.phoneMax} {
    gap: 12px;
    margin-top: 20px;
    padding-top: 20px;
  }
`;

export const FeatureTitle = styled.h3`
  font-family: ${({ theme }) => theme.typography.fonts.body};
  font-size: 14px;
  font-weight: 650;
  letter-spacing: -0.01em;
  line-height: 1.5;
  margin: 0 0 5px;

  @media ${deviceMax.tabletWideMax} {
    font-size: 13px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 14px;
  }
`;

export const FeatureDescription = styled.p`
  color: ${({ theme }) => theme.colors.brand.muted};
  font-size: 13px;
  line-height: 1.65;
  margin: 0;

  @media ${deviceMax.tabletWideMax} {
    font-size: 12px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 13px;
  }
`;
